<template>
  <div class="bg-gradient-to-tr from-blue-600 via-sky-600 to-indigo-500 h-64 pt-[56px] w-full flex items-center dark:bg-gradient-to-tr dark:from-gray-900 dark:via-slate-800 dark:to-gray-900">
    <div class="container mx-auto">
      <div class="2xl:border-l-4 xl:border-l-4 lg:border-l-4 md:border-l-4 border-white dark:border-lime-600 2xl:text-start xl:text-start md:text-start text-center">
        <h1 class="font-bold text-4xl text-white mb-2 indent-2 dark:text-lime-500">{{ $t('footer.useful-links') }}</h1>
      </div>

      <a onclick="window.history.back()" class="text-white dark:text-lime-500 2xl:hidden xl:hidden lg:hidden md:hidden inline-flex items-center font-medium hover:text-gray-900 dark:hover:text-white cursor-pointer justify-center w-full">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 mr-2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
        </svg>
        <span>{{ $t('table.go-back') }}</span>
      </a>

      <nav aria-label="Breadcrumb" class="2xl:block xl:block lg:block md:block hidden">
        <ol class="flex space-x-1 md:space-x-3 text-white dark:text-lime-500">
          <li class="flex items-center hover:text-gray-900 dark:hover:text-white cursor-pointer hover:color-gray-900">
            <a @click="this.$router.push('/')" class="inline-flex items-center font-medium">
              <svg class="w-4 h-4 mr-2" fill="white" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
              </svg>
              <span class="hidden sm:block">{{ $t('ceo-message.main-screen') }}</span>
            </a>
          </li>
          <li>
            <div class="flex items-center">
              <svg class="w-6 h-6 text-gray-400" fill="white" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clip-rule="evenodd"></path>
              </svg>
              <div class="ml-1 font-medium select-none">{{ $t('navbar.press-center') }}</div>
            </div>
          </li>
          <li aria-current="page">
            <div class="flex items-center">
              <svg class="w-6 h-6 text-gray-400" fill="white" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clip-rule="evenodd"></path>
              </svg>
              <span class="ml-1 font-medium md:ml-2 select-none">{{ $t('footer.useful-links') }}</span>
            </div>
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="container mx-auto">
    <div class="grid gap-4 py-10 2xl:grid-cols-4 xl:grid-cols-4 lg:grid-cols-4 grid-cols-2 px-4">
      <a href='https://www.mf.uz/' target="_blank" class="flex flex-col py-4 rounded-lg text-sm border text-center hover:border-blue-500 dark:border-lime-500 dark:bg-gray-900 dark:text-lime-500 hover:scale-[95%] hover:shadow-md transition-all ease-linear cursor-pointer">
        <div class="flex flex-col items-center justify-around h-full">
          <img src="../assets/img/links/depoImg.webp" alt="" class="w-20 pb-2">
          <h2 class="select-none">{{ $t('useful.first') }}</h2>
        </div>
      </a>

      <a href='https://cbu.uz/' target="_blank" class="flex flex-col py-4 rounded-lg text-sm border text-center hover:border-blue-500 dark:border-lime-500 dark:bg-gray-900 dark:text-lime-500 hover:scale-[95%] hover:shadow-md transition-all ease-linear cursor-pointer">
        <div class="flex flex-col items-center justify-around h-full">
          <img src="../assets/img/links/2.webp" alt="" class="w-20 pb-2">
          <h2 class="select-none">{{ $t('useful.second') }}</h2>
        </div>
      </a>

      <a href='https://davaktiv.uz' target="_blank" class="flex flex-col py-4 rounded-lg text-sm border text-center hover:border-blue-500 dark:border-lime-500 dark:bg-gray-900 dark:text-lime-500 hover:scale-[95%] hover:shadow-md transition-all ease-linear cursor-pointer">
        <div class="flex flex-col items-center justify-around h-full">
          <img src="../assets/img/links/depoImg.webp" alt="" class="w-20 pb-2">
          <h2 class="select-none">{{ $t('useful.third') }}</h2>
        </div>
      </a>

      <a href='https://uzse.uz/' target="_blank" class="flex flex-col py-4 rounded-lg text-sm border text-center hover:border-blue-500 dark:border-lime-500 dark:bg-gray-900 dark:text-lime-500 hover:scale-[95%] hover:shadow-md transition-all ease-linear cursor-pointer">
        <div class="flex flex-col items-center justify-around h-full">
          <img src="../assets/img/links/5.webp" alt="" class="w-20 pb-2">
          <h2 class="select-none">{{ $t('useful.fourth') }}</h2>
        </div>
      </a>

      <a href='https://lex.uz/uz/' target="_blank" class="flex flex-col py-4 rounded-lg text-sm border text-center hover:border-blue-500 dark:border-lime-500 dark:bg-gray-900 dark:text-lime-500 hover:scale-[95%] hover:shadow-md transition-all ease-linear cursor-pointer">
        <div class="flex flex-col items-center justify-around h-full">
          <img src="../assets/img/links/6.svg" alt="" class="w-20 pb-2">
          <h2 class="select-none">{{ $t('useful.fifth') }}</h2>
        </div>
      </a>

      <a href='https://aecsd.org/' target="_blank" class="flex flex-col py-4 rounded-lg text-sm border text-center hover:border-blue-500 dark:border-lime-500 dark:bg-gray-900 dark:text-lime-500 hover:scale-[95%] hover:shadow-md transition-all ease-linear cursor-pointer">
        <div class="flex flex-col items-center justify-around h-full">
          <img src="../assets/img/links/7.webp" alt="" class="w-20 pb-2">
          <h2 class="select-none">{{ $t('useful.sixth') }}</h2>
        </div>
      </a>

      <a href='https://www.acgcsd.org/' target="_blank" class="flex flex-col py-4 rounded-lg text-sm border text-center hover:border-blue-500 dark:border-lime-500 dark:bg-gray-900 dark:text-lime-500 hover:scale-[95%] hover:shadow-md transition-all ease-linear cursor-pointer">
        <div class="flex flex-col items-center justify-around h-full">
          <img src="../assets/img/links/8.jpg" alt="" class="w-20 pb-2">
          <h2 class="select-none">{{ $t('useful.seventh') }}</h2>
        </div>
      </a>

      <a href='https://my.gov.uz/ru' target="_blank" class="flex flex-col py-4 rounded-lg text-sm border text-center hover:border-blue-500 dark:border-lime-500 dark:bg-gray-900 dark:text-lime-500 hover:scale-[95%] hover:shadow-md transition-all ease-linear cursor-pointer">
        <div class="flex flex-col items-center justify-around h-full">
          <img src="../assets/img/links/depoImg.webp" alt="" class="w-20 pb-2">
          <h2 class="select-none">{{ $t('useful.eighth') }}</h2>
        </div>
      </a>
      <a href='https://napp.uz/ru' target="_blank" class="flex flex-col py-4 rounded-lg text-sm border text-center hover:border-blue-500 dark:border-lime-500 dark:bg-gray-900 dark:text-lime-500 hover:scale-[95%] hover:shadow-md transition-all ease-linear cursor-pointer">
        <div class="flex flex-col items-center justify-around h-full">
          <img src="../assets/img/links/9.png" alt="" class="w-20 pb-2">
          <h2 class="select-none">{{ $t('useful.ninth') }}</h2>
        </div>
      </a>
    </div>
  </div>

</template>